import React from 'react';
import { Card, Flex, Image, Text } from '@aws-amplify/ui-react';
import { useProfileQuery } from '../profile/api/useProfileQuery';

export default function FactsSheetProfileCard() {
  const { data: profileData, isSuccess } = useProfileQuery();

  if (isSuccess) {
    return (
      <>
        <Card variation="elevated" padding="small" margin="small">
          <Flex
            direction="column"
            justifyContent="flex-start"
            alignItems="flex-start"
            padding="32px 32px 32px 32px"
          >
            <Flex>
              <Image
                width="80px"
                height="80px"
                src="/images/user.jpg"
                borderRadius="64px"
                objectFit="cover"
              ></Image>
              <Flex gap={20} direction="column">
                <Text
                  fontFamily="Inter"
                  fontSize="24px"
                  fontWeight="700"
                  lineHeight="24px"
                  children={`${profileData?.firstName || ''} ${
                    profileData?.lastName || ''
                  }`}
                />
                <Flex
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  gap={80}
                >
                  <Text
                    fontFamily="Inter"
                    children={`DOB: ${profileData?.dob || ''}`}
                  ></Text>

                  <Text
                    fontFamily="Inter"
                    children={`Gender: ${profileData?.gender || ''}`}
                  />
                </Flex>
              </Flex>
            </Flex>
          </Flex>
        </Card>
      </>
    );
  }
}
